import { Form } from "@/helpers/Form";
import Pager from "@/helpers/Pager";
import { FilterModel as TimeSheetFilterModel, UserStatus } from "../services/TimeSheetService";
import { FilterModel as AbsencesFilterModel } from "../services/AbsencesService";
import { FilterModel as EmployeesListFilterModel } from "../services/EmployeesService";
import { FilterCitiesStatisticsModel, FilterCountryStatisticsModel, FilterRegionsStatisticsModel, ListFilterModel} from "../services/StatisticsService";
import { DateTime } from "luxon";

const firstDayOfThisMonth = DateTime.utc().startOf('month');

export default {
    namespaced: true,
    state: {
        timeSheet: {
            filter: Form.createPersistedState<TimeSheetFilterModel>({
                regionPublicId: null,
                cityPublicId: null,
                userPublicId: null,
                department: null,
                districtIds: [],
                range: UserStatus.All,
            }, undefined, 'renterTimeSheetFilter'),
            pager: new Pager(1, undefined, 'GivenName', 'ASC'),
            refetchEmployees: false
        },
        absences: {
            filter: Form.createPersistedState<AbsencesFilterModel>({
                dateFromUtc: null,
                dateToUtc: null
            }, undefined, 'renterAbsencesFilter'),
            pager: new Pager(1, undefined, 'UserFullName', 'ASC')
        },
        hk: {
            pagerMissing: new Pager(1, 10, 'surname', 'ASC'),
            pagerHours: new Pager(1, 10, 'user.surname', 'ASC'),
            pagerMonth: new Pager(1, 10, 'user.surname', 'ASC'),
            pagerTasks: new Pager(1, 10, 'user.surname', 'ASC'),
            pagerMixed: new Pager(1, 10, 'user.surname', 'ASC'),
        },
        maintenance: {
            pagerMissing: new Pager(1, 10, 'surname', 'ASC'),
            pagerHours: new Pager(1, 10, 'user.surname', 'ASC'),
            pagerMonth: new Pager(1, 10, 'user.surname', 'ASC'),
        },
        coordinator: {
            pagerMissing: new Pager(1, 10, 'surname', 'ASC'),
            pagerMonth: new Pager(1, 10, 'user.surname', 'ASC'),
        },
        driver: {
            pagerMissing: new Pager(1, 10, 'surname', 'ASC'),
            pagerHours: new Pager(1, 10, 'user.surname', 'ASC'),
        },
        employees: {
            filter: Form.createPersistedState<EmployeesListFilterModel>({
                searchDate: firstDayOfThisMonth
            }, undefined, 'renterEmployeesFilter'),
            pager: new Pager(1, undefined, 'UserFullName', 'ASC')
        },
        statistics: {
            pagerEmployees: new Pager(1, 20, 'UserFullName', 'ASC'),
            filterEmployees: Form.createPersistedState<ListFilterModel>({
                searchDate: firstDayOfThisMonth,
                cityPublicId: null,
                regionPublicId: null,
                department: 'default',
                userPublicId: null,
            }, undefined, 'renterStatisticsEmployeesFilter'),
            filterCitiesStatistics: Form.createPersistedState<FilterCitiesStatisticsModel>({
                searchDate: firstDayOfThisMonth,
                cityPublicId: null
            }, undefined, 'renterStatisticsCitiesFilter'),
            filterRegionsStatistics: Form.createPersistedState<FilterRegionsStatisticsModel>({
                searchDate: firstDayOfThisMonth,
                regionPublicId: null
            }, undefined, 'renterStatisticsRegionsFilter'),
            filterCountryStatistics: Form.createPersistedState<FilterCountryStatisticsModel>({
                searchDate: firstDayOfThisMonth
            }, undefined, 'renterStatisticsCountryFilter'),
        },
        statisticsViewPermissions: {},
    }
};
